const PTSports = [
    {
        title: "Diego Costa multado em mais de meio milhão de euros por fuga ao fisco",
        description: "O futebolista Diego Costa, avançado do Atlético Madrid, foi nesta quinta-feira multado em 543 mil euros, depois de ter assumido que defraudou o fisco espanhol em 2014, em cerca de 1,1 milhões de euros. Em tribunal, na capital espanhola, o jogador de 31 anos deu-se como culpado de ter ocultado receitas provenientes de um contrato de patrocínio com uma marca desportiva, quando estava ao serviço do Chelsea.",
        url: "https://www.publico.pt/2020/06/04/desporto/noticia/diego-costa-multado-meio-milhao-euros-fuga-fisco-1919445",
        image: "https://imagens.publico.pt/imagens.aspx/1476813?tp=UH&db=IMAGENS&type=JPG&w=1024",
        publishedAt: "4 de Junho de 2020, 17:06",
        source: {
            url: "https://www.publico.pt/",
            name: "Publico"
        }
    },
    {
        title: "Alemanha não vai punir jogadores que manifestaram apoio a George Floyd",
        description: "Quatro futebolistas tiveram gestos de apoio ao combate ao racismo e a federação alemã chegou a abrir um inquérito, como determinam os regulamentos. O organismo deixa agora claro que estas acções dos jogadores merecem “respeito e compreensão”, o que se aplicará a outras situações semelhantes no futuro.",
        url: "https://www.publico.pt/2020/06/03/desporto/noticia/alemanha-nao-vai-punir-jogadores-manifestaram-apoio-george-floyd-1919294",
        image: "https://imagens.publico.pt/imagens.aspx/1476311?tp=UH&db=IMAGENS&type=JPG&w=1024",
        publishedAt: "3 de Junho de 2020, 16:41",
        source: {
            url: "https://www.publico.pt/",
            name: "Publico"
        }
    },
    {
        title: "Nike lança nova bola com tecnologia revolucionária",
        description: "A Nike anunciou o lançamento de uma nova bola, a Nike Flight, com uma tecnologia que promete ser revolucionária no mundo do futebol.",
        url: "https://www.jn.pt/desporto/nike-lanca-nova-bola-com-tecnologia-revolucionaria-12364662.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=37967ec5-1f99-4d80-be92-6841b374bd19&w=744&h=495&t=20200629103423",
        publishedAt: "2020-06-29T21:00:47Z",
        source: {
            url: "https://www.jn.pt/",
            name: "JN"
        }
    },
    {
        title: "O segredo para o sucesso do Liverpool",
        description: "O Liverpool é uma das equipas mais bem-sucedidas dos últimos anos. A nível desportivo, em três épocas chegou a uma final, conquistou a Liga dos Campeões e venceu a Premier League, 30 anos depois do último triunfo. Por detrás deste sucesso desportivo está também um bom trabalho na gestão do clube.",
        url: "https://www.jn.pt/desporto/o-segredo-para-o-sucesso-do-liverpool-12356356.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=ffd79992-374a-40f8-a9ce-61fc4e086310&w=744&h=495&t=20200626141808",
        publishedAt: "26 Junho 2020 às 14:51",
        source: {
            url: "https://www.jn.pt/",
            name: "JN"
        }
    },
    {
        title: "Lewis Hamilton participou em protesto contra o racismo em Londres",
        description: "O piloto de Fórmula 1, seis vezes campeão do mundo, marcou presença no protesto pacífico do movimento Black Lives Matter que se realizou no fim de semana em Inglaterra, nas cidades de Leeds e Londres.",
        url: "https://www.jn.pt/desporto/lewis-hamilton-participou-em-protesto-contra-o-racismo-em-londres-12337786.html?autoplay=true",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=a491756f-126e-490b-a7ad-cebbd92c185f&t=20200622110803",
        publishedAt: "22 Junho 2020 às 11:58",
        source: {
            url: "https://www.jn.pt/",
            name: "JN"
        }
    },
    {
        title: "Conor McGregor anuncia retirada pela terceira vez em quatro anos",
        description: "O lutador irlandês de artes marciais mistas Conor McGregor, de 31 anos, anunciou hoje, pela terceira vez em quatro anos, a sua retirada dos combates, depois de já o ter feito em 2016 e 2019.",
        url: "https://www.jn.pt/desporto/conor-mcgregor-anuncia-retirada-pela-terceira-vez-em-quatro-anos-12287089.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=f2067f4a-b517-4144-9ace-e3bf64a79a91&w=744&h=495&t=20200607110700",
        publishedAt: "07 Junho 2020 às 12:06",
        source: {
            url: "https://www.jn.pt/",
            name: "JN"
        }
    },
    {
        title: "Tóquio2020 garante 80% das sedes desportivas para 2021",
        description: "Os organizadores dos Jogos Olímpicos Tóquio2020 anunciaram esta sexta-feira que vão poder contar em 2021 com 80% das sedes desportivas previstas inicialmente para o evento, adiado um ano devido à pandemia de covid-19.",
        url: "https://www.jn.pt/desporto/toquio2020-garante-80-das-sedes-desportivas-para-2021-12304041.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=fc9afbd8-ae67-47d2-8af6-33da5c5a3b6e&w=744&h=495&t=20200612111056",
        publishedAt: "12 Junho 2020 às 12:10",
        source: {
            url: "https://www.jn.pt/",
            name: "JN"
        }
    },
    {
        title: "Auriol Dongmo bate recorde de Portugal no lançamento do peso",
        description: "A atleta de 29 anos, nascida nos Camarões e que conta com nacionalidade portuguesa desde outubro de 2019, conseguiu bater o recorde nacional (18,82 metros atingidos no sábado) no segundo ensaio, com 18,90 metros, mas fez ainda melhor no sexto e último ensaio, com 19,27 metros.",
        url: "https://desporto.sapo.pt/modalidades/atletismo/artigos/auriol-dongmo-bate-recorde-de-portugal-no-lancamento-do-peso-2",
        image: "https://thumbs.web.sapo.io/?W=775&H=0&delay_optim=1&webp=1&epic=OTU5yy+lRsLRfwD2mfJUD2IZ5+l1fprTLpBqoISdP8xzAxVHHe64JPOhlfXeKheRy1YvIx2/PaLxA5btJhh/Rbl1BDTvDnrOz4UdnNgI3Bx6/XM=",
        publishedAt: "24 jun 2020 20:50",
        source: {
            url: "https://desporto.sapo.pt/",
            name: "Sapo"
        }
    },
    {
        title: "Pelé e os inesquecíveis 'golos' que não marcou no Mundial de 1970",
        description: "Pelé e os inesquecíveis 'golos' que não marcou aos guarda-redes Viktor, Banks e Mazurkiewicz no campeonato do México de 1970, competição conquistada pelo Brasil. Lances que ainda são lembrados, apesar de terem acontecido há meio século.",
        url: "https://desporto.sapo.pt/futebol/artigos/pele-e-os-inesqueciveis-golos-que-nao-marcou-no-mundial-de-1970",
        image: "https://thumbs.web.sapo.io/?W=775&H=0&delay_optim=1&webp=1&epic=Y2QxFt3SUbSDnMG4N/V/KuqYVOXI9uiy4BaEe1utxQ1POSeV/IjvEboRVO8S11aFYDE0LpiEs2uNnhyMgMqKcnHxPO1+OQCZ8627BpL1yIk8ukQ=",
        publishedAt: "16 jun 2020 20:22",
        source: {
            url: "https://desporto.sapo.pt/",
            name: "Sapo"
        }
    },
    {
        title: "Basquetebol: Oliveirense anuncia reforço para 2020/21",
        description: "O extremo-base norte-americano EC Matthews, de 24 anos e 1,96 metros, jogava na NBA G-League, onde representou os Erie BayHawks e os Raptors 905 e vai representar a Oliveirense em 2020/21.",
        url: "https://desporto.sapo.pt/modalidades/basquetebol/artigos/basquetebol-oliveirense-anuncia-reforco-para-202021",
        image: "https://thumbs.web.sapo.io/?W=775&H=0&delay_optim=1&webp=1&epic=NjQ13+l12mSMlieXTdTflIZEEIK5HxkeTkT7NvYDiOioMtR3W2ViNNgmxEdMnfTa1tCQUyBS6mR/ylW5yxxt112rTJvVjzRzaH7zXr0xio2+6WQ=",
        publishedAt: "18 jun 2020 07:43",
        source: {
            url: "https://desporto.sapo.pt/",
            name: "Sapo"
        },
    },
    {
        title: "Fu Yu e Jieni Shao nos quartos de final do Open da Hungria de ténis de mesa",
        description: "As portuguesas Fu Yu e Jieni Shao apuraram-se hoje para os quartos de final do torneio de pares femininos do Open da Hungria de ténis de mesa, a decorrer até domingo em Budapeste.",
        url: "https://desporto.sapo.pt/modalidades/mais-modalidades/artigos/fu-yu-e-jieni-shao-nos-quartos-de-final-do-open-da-hungria-de-tenis-de-mesa",
        image: "https://thumbs.web.sapo.io/?W=775&H=0&delay_optim=1&webp=1&epic=Yjhh1cpRGnbaKfamSwelKvpFBrnDLDS6U6YR36VPGiFcznA2CnxTAtKsqhUNtcCxnXZZi5fmosYNrbl6L8hPaf9XXciRk2RdlMv4TexEKZ6pv+I=",
        publishedAt: "20 fev 2020 23:59",
        source: {
            url: "https://desporto.sapo.pt/",
            name: "Sapo"
        },
    },
    {
        title: "Opinião: Jiu-Jitsu em Portugal",
        description: "A primeira vez que ouvi falar da presença de Jiu-Jitsu Brasileiro em Portugal foi no longínquo ano de 1998. Na altura praticava Kickboxing no Ginásio Superstar, que estava a organizar o primeiro evento de Vale-Tudo nacional com o professor Lauro Figueiroa – considerado o founding father do Jiu-Jitsu em Portugal.",
        url: "https://desporto.sapo.pt/modalidades/mais-modalidades/artigos/opiniao-jiu-jitsu-em-portugal",
        image: "https://thumbs.web.sapo.io/?W=775&H=0&delay_optim=1&webp=1&epic=NjIwcUp1JmaUq80PXg89dEUGRHggf1+KPDs+eMcqZrChFOktKmEVi2vfh8hWYuGxXCHcsk/tI7lZaiX7Xbiu2hMXq+ujVTDaXMq4V+lQi1d495U=",
        publishedAt: "30 jan 2020 17:09",
        source: {
            url: "https://desporto.sapo.pt/",
            name: "Sapo"
        },
    },
    {
        title: "Ricardinho sonha retirar-se da seleção após ser campeão mundial",
        description: "Ricardinho, considerado por seis vezes como o melhor jogador de futsal do mundo, admitiu hoje ter o sonho de conquistar o Mundial e retirar-se da seleção portuguesa para dar lugar aos jogadores jovens.",
        url: "https://www.noticiasaominuto.com/desporto/1493557/ricardinho-sonha-retirar-se-da-selecao-apos-ser-campeao-mundial",
        image: "https://media-manager.noticiasaominuto.com/1920/28151574.jpg",
        publishedAt: "22:57 - 26/05/20",
        source: {
            url: "https://www.noticiasaominuto.com/",
            name: "Notíciasaominuto"
        },
    },
    {
        title: "Cédric Soares assina contrato de longo prazo com Arsenal",
        description: 'O futebolista internacional português Cédric Soares assinou um contrato de "longo prazo" com o Arsenal, depois de ter chegado aos "gunners" por empréstimo do Southampton, anunciou o clube londrino, sem revelar a duração do vínculo.',
        url: "https://www.rtp.pt/noticias/futebol-internacional/cedric-soares-assina-contrato-de-longo-prazo-com-arsenal_d1239559",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/1b/1b85c88c5f98cf6ffee62949b0d3627f?w=860&q=90&rect=0,75,1200,658&auto=format",
        publishedAt: "24 jun 2020 10:56",
        source: {
            url: "https://www.rtp.pt/",
            name: "RTP Desporto"
        },
    },
    {
        title: "Tottenham de José Mourinho regressa às vitórias",
        description: 'O Tottenham, treinado pelo português José Mourinho, colocou fim a uma série de sete jogos sem vitórias, ao bater em casa o West Ham por 2-0, em jogo da 31.ª jornada da Liga inglesa de futebol.',
        url: "https://www.rtp.pt/noticias/futebol-internacional/tottenham-de-jose-mourinho-regressa-as-vitorias_d1239529",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/bc/bc65da6365ba0269e7981dd805d95d55?w=860&q=90&rect=0,93,2500,1371&auto=format",
        publishedAt: "24 jun 2020 08:47",
        source: {
            url: "https://www.rtp.pt/",
            name: "RTP Desporto"
        },
    },
    {
        title: "Luís Castro encara título conquistado na Ucrânia com “sensação de alívio”",
        description: 'O treinador português Luís Castro assumiu esta terça-feira ter vivido a conquista do título ucraniano de futebol, alcançada no sábado no comando do Shakhtar Donetsk, com uma “sensação de alívio”, pela conquista do objetivo e pela retoma do campeonato.',
        url: "https://www.rtp.pt/noticias/futebol-internacional/luis-castro-encara-titulo-conquistado-na-ucrania-com-sensacao-de-alivio_d1239357",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/e8/e8b2cc19affa19a5e86fbca6e3a0d0cc?w=860&q=90&rect=0,72,1508,827&auto=format",
        publishedAt: "23 jun 2020 15:14",
        source: {
            url: "https://www.rtp.pt/",
            name: "RTP Desporto"
        },
    },
    {
        title: "Rali Dakar com percurso novo e inteiramente na Arábia Saudita",
        description: 'O Rali Dakar, prova rainha de todo-o-terreno, vai voltar a realizar-se inteiramente na Arábia Saudita, apesar de ter em 2021 um percurso "100% novo" e "menos rápido" do que este ano, anunciou hoje a organização.',
        url: "https://www.rtp.pt/noticias/motores/rali-dakar-com-percurso-novo-e-inteiramente-na-arabia-saudita_d1236283",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/7f/7f3c8697eb085ee2f497532f8e234ca3?w=860&q=90&rect=0,307,5184,2842&auto=format",
        publishedAt: "11 jun 2020 13:38",
        source: {
            url: "https://www.rtp.pt/",
            name: "RTP Desporto"
        },
    },
    {
        title: "Relação de Lisboa nega recurso ao Ministério Público e mantém os 90 crimes a Rui Pinto",
        description: 'O Tribunal da Relação de Lisboa negou hoje provimento ao recurso do Ministério Público (MP), o qual pedia que Rui Pinto, criador do Football Leaks, fosse julgado por 147 em vez dos 90 crimes pelos quais foi pronunciado.',
        url: "https://www.rtp.pt/noticias/futebol-nacional/relacao-de-lisboa-nega-recurso-ao-ministerio-publico-e-mantem-os-90-crimes-a-rui-pinto_d1233968",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/54/54e8e62be3d09b3ab425a70a53396e44?w=860&q=90&rect=0,89,1504,825&auto=format",
        publishedAt: "2 jun 2020 23:12",
        source: {
            url: "https://www.rtp.pt/",
            name: "RTP Desporto"
        },
    },
    {
        title: "André Villas-Boas renova com o Marselha por mais duas épocas",
        description: 'O treinador português André Villas-Boas permanecerá na próxima época no comando técnico do Olympique de Marselha, disse fonte do clube francês à agência France Presse, após rumores de que estaria de saída.',
        url: "https://www.rtp.pt/noticias/futebol-internacional/andre-villas-boas-renova-com-o-marselha-por-mais-duas-epocas_d1231842",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/ff/ff92141f7d32bc52414013fc667f0a78?w=860&q=90&rect=0,15,3500,1919&auto=format",
        publishedAt: "26 mai 2020 09:58",
        source: {
            url: "https://www.rtp.pt/",
            name: "RTP Desporto"
        },
    },
    {
        title: "Liverpool: Atlético de Madrid levou a 41 mortes após infeções, diz estudo",
        description: 'Um estudo publicado pelo jornal Sunday Times conclui que o jogo da Liga dos Campeões de futebol entre Liverpool e Atlético de Madrid, em 11 de março, levou a 41 mortes por infeção de covid-19.',
        url: "https://www.rtp.pt/noticias/futebol-internacional/liverpool-atletico-de-madrid-levou-a-41-mortes-apos-infecoes-diz-estudo_d1231469",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/d1/d187a6202507f818566f3af2e85a97b6?w=860&q=90&rect=9,0,1483,813&auto=format",
        publishedAt: "24 mai 2020 17:13",
        source: {
            url: "https://www.rtp.pt/",
            name: "RTP Desporto"
        },
    },
    {
        title: "Naomi Osaka foi a desportista mais bem paga em 2019",
        description: 'A tenista japonesa Naomi Osaka, de 22 anos, foi em 2019 a desportista mais bem paga com receitas na ordem dos 34,3 milhões de euros, destronando Serena Williams, que tinha liderado a tabela da Forbes nos últimos quatro anos.',
        url: "https://www.rtp.pt/noticias/outras-modalidades/naomi-osaka-foi-a-desportista-mais-bem-paga-em-2019_d1231096",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/c4/c46d7f8e551e2f22cc776cb74e0f261a?w=860&q=90&rect=0,91,1500,822&auto=format",
        publishedAt: "22 mai 2020 19:04",
        source: {
            url: "https://www.rtp.pt/",
            name: "RTP Desporto"
        },
    },
    {
        title: "Sebastian Vettel deixa a Ferrari no final da temporada",
        description: 'O alemão Sebastian Vettel vai deixar a Ferrari no final da temporada, anunciou a equipa italiana de Fórmula 1, que não especificou o nome do sucessor.',
        url: "https://www.rtp.pt/noticias/outras-modalidades/sebastian-vettel-deixa-a-ferrari-no-final-da-temporada_d1228033",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/57/573771b1899ce46a1c35def5754bbb7a?w=860&q=90&rect=0,9,1280,702&auto=format",
        publishedAt: "12 mai 2020 09:00",
        source: {
            url: "https://www.rtp.pt/",
            name: "RTP Desporto"
        },
    },
    {
        title: "Campeonato de Portugal é primeira meta do sonho do Oriental Dragon de Qi Chen.",
        description: 'Com apenas seis anos de existência, sem massa adepta nem campo próprio, o Oriental Dragon chegou esta época ao Campeonato de Portugal, primeira meta do sonho de Qi Chen no caminho rumo às competições profissionais de futebol.',
        url: "https://www.rtp.pt/noticias/futebol-nacional/campeonato-de-portugal-e-primeira-meta-do-sonho-do-oriental-dragon-de-qi-chen_d1227424",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/f3/f39455b115bbbf58159bb17e1061b216?w=860&q=90&rect=0,15,600,329&auto=format",
        publishedAt: "9 mai 2020 10:38",
        source: {
            url: "https://www.rtp.pt/",
            name: "RTP Desporto"
        },
    }
]

export default PTSports